import BaseModel from "./BaseModel";

export default class Campaigns extends BaseModel {
	constructor(restApi) {
		super(restApi, "Campaigns", null);
		
		this.restApi = restApi;
	}
  
	static moduleSingular() {
		return "Campaign";
	}
	
	static modulePlural() {
		return "Campaigns";
	}
  
  static nameMapping() {
    return [
      { "modelName": "id", "apiName": "id" },
      { "modelName": "name", "apiName": "name", "defaultValue": "" },
      { "modelName": "startDate", "apiName": "startDate", "defaultValue": "" },
      { "modelName": "hasEndDate", "apiName": "hasEndDate", "defaultValue": true },
      { "modelName": "endDate", "apiName": "endDate", "defaultValue": "" },
      { "modelName": "data", "apiName": "data", "defaultValue": "" },
      { "modelName": "clientId", "apiName": "clientId", "defaultValue": "" },
      
      { "modelName": "client", "apiName": "client", "defaultValue": "" }        // relational
    ];
  }
	
	static createModel(restApi, jsonObject) {
		return BaseModel.createModel(Campaigns, restApi, jsonObject, Campaigns.nameMapping());
	}
}



// WEBPACK FOOTER //
// ./src/modules/Campaigns.js